/*
 * @Author: yaoyuting
 * @Date: 2019-08-27 11:38:24
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-15 15:00:12
 * @Descripttion:
 */
export function trimHtml(str) {
  if (!str) return "";
  str = str.replace(/(\n)/g, "");
  str = str.replace(/(\t)/g, "");
  str = str.replace(/(\r)/g, "");
  str = str.replace(/<\/?[^>]*>/g, "");
  // str = str.replace(/\s*/g, '');
  str = str.replace(/<[^>]*>/g, "");
  return str;
}
export function goPAGE() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    /* window.location.href="你的手机版地址"; */
    return "m";
  }
  /* window.location.href="你的电脑版地址";    */
  return "pc";
}

export function getNavigator() {
  const u = navigator.userAgent;
  // console.log('navigator.userAgent\n\n\n\n', u)
  const obj = {};
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  obj.device = "h5";
  if (isAndroid) {
    obj.device = "android";
  }
  if (isIOS) {
    obj.device = "ios";
  }
  obj.isApp = u.indexOf("dianjiemian") > -1;
  // if (process.env.NODE_ENV != 'production') {
  // 	obj.isApp = true
  // }
  return obj;
}

// export const baseURL = "http://47.98.110.210:8081/"
// http://47.115.200.174:8080
export function FormatTime(number, format) {
  if (number == "0" || !number) return " ";
  const formateArr = ["Y", "M", "D", "h", "m", "s"];
  const returnArr = [];
  const date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));
  for (const i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : `0${n}`;
}

/*
  ios端浏览器日期格式化有兼容性问题, ios只识别yyyy/mm/dd这类斜杠格式的日期。
  如2022-03-25 10:03:59 要转换成2022/03/25 10:03:59
*/
export function formatDateStr(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return;
  return /-/g.test(dateStr) ? dateStr.replace(/-/g, "/") : dateStr;
}

export function timestampConvertTime(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + " ";
  var M = date.getMonth() + 1;
  //console.log(M);
  // (date.getMonth() + 1 < 10
  //   ? "0" + (date.getMonth() + 1)
  //   : date.getMonth() + 1) + " ";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + ",";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  if (M == "1") {
    M = "Jan";
  } else if (M == "2") {
    M = "Feb";
  } else if (M == "3") {
    M = "Mar";
  } else if (M == "4") {
    M = "Apr";
  } else if (M == "5") {
    M = "May";
  } else if (M == "6") {
    M = "Jun";
  } else if (M == "7") {
    M = "Jul";
  } else if (M == "8") {
    M = "Aug";
  } else if (M == "9") {
    M = "Sep";
  } else if (M == "10") {
    M = "Oct";
  } else if (M == "11") {
    M = "Nov";
  } else if (M == "12") {
    M = "Dec";
  }
  return M + " " + D + Y + h + m + s + " " + "UTC";
  //return Y + M + D + h + m + s; //2020-07-30 01:05:54
}
export function timestampConvertTimea(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + " ";
  var M = date.getMonth() + 1;
  //console.log(M);
  // (date.getMonth() + 1 < 10
  //   ? "0" + (date.getMonth() + 1)
  //   : date.getMonth() + 1) + " ";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + ",";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  if (M == "1") {
    M = "Jan";
  } else if (M == "2") {
    M = "Feb";
  } else if (M == "3") {
    M = "Mar";
  } else if (M == "4") {
    M = "Apr";
  } else if (M == "5") {
    M = "May";
  } else if (M == "6") {
    M = "Jun";
  } else if (M == "7") {
    M = "Jul";
  } else if (M == "8") {
    M = "Aug";
  } else if (M == "9") {
    M = "Sep";
  } else if (M == "10") {
    M = "Oct";
  } else if (M == "11") {
    M = "Nov";
  } else if (M == "12") {
    M = "Dec";
  }
  // D=Number(D-1
  return M + "," + D + Y ;
  //return Y + M + D + h + m + s; //2020-07-30 01:05:54
}
export function timestampConvertTime1(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return M + D; //2020-07-30 01:05:54
}
export function timestampConvertTime2(timestamp) {
  let _timestamp = timestamp;
  if (_timestamp.length == 10) {
    _timestamp = Number(_timestamp) * 1000;
  }
  var date = new Date(Number(_timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

  return Y + M + D; //2020-07-30 01:05:54
}
export function formatSeconds(value) {
  var theTime = parseInt(value); // 需要转换的时间秒
  var theTime1 = 0; // 分
  var theTime2 = 0; // 小时
  var theTime3 = 0; // 天
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
      if (theTime2 > 24) {
        //大于24小时
        theTime3 = parseInt(theTime2 / 24);
        theTime2 = parseInt(theTime2 % 24);
      }
    }
  }
  let res = "";
  if (theTime1 == 0) {
    // v-if="this.nowLang=='cn'"

    res = `${theTime} seconds ago`;
  } else {
    if (theTime == 0) {
      res += `${theTime1} minutes ago`;
    } else {
      res += `${theTime1} minutes `;
      res += `${theTime} seconds ago`;
    }
  }
  if (theTime2 > 0 && theTime2 < 24) {
    if (theTime1 == 0) {
      res = `${theTime2} hour ago`;
    } else {
      res = `${theTime2} hour ` + `${theTime1} minutes ago`;
    }
  }
  if (theTime3 > 0) {
    if (theTime2 == 0) {
      res = `${theTime3} days ago`;
    } else {
      res = `${theTime3} days ` + `${theTime2} hour ago`;
    }
  }
  return res;
}
export function listTypea(val){
  if (val == -1) {
    val= "Genesis";
  } else if (val == 1) {
    val= "Transfer"; 
  } else if (val == 2) {
    val = "Stake"; 
  } else if (val == 3) {
    val = "Unstake"; 
  } else if (val == 4) {
    val = "Delegate";
  } else if (val == 5) {
    val = "Withdraw";
  } else if (val== 99) {
    val = "Bonus";
  } else if (
    val== "from" ||
    val == "to"
  ) {
    val = "Transfer";
  } else if (val == "gas") {
    val = "Signature Rewards";
  } else if (
    val == "toAward" //
  ) {
    val = "Bonus";
  }else if(val == "commission"){
    val = "Commission";
  }else if(val==-1){
    val ="Genesis";
  }
  return val;
}
export function listType(value) {
  if (value == "from" || value == "to" || value == 1) {
    value = "Transfer";
  } else if (value == "gas") {
    value = "Signature Rewards";
  } else if (value == "fromAward" || value == "toAward") {
    value = "Bonus";
  } else if (value == 2) {
    value = "Stake";
  } else if (value == 3) {
    value = "Unstake";
  } else if (value == 5) {
    value = "Withdraw";
  } else if (value == 4) {
    value = "Delegate";
  } else if (value == 99) {
    value = "Bonus";
  } else if (value == "commission") {
    value = "Commission";
  } else if(value==7){
    value = "ContractCreation";
  } else if(value==-1){
    value ="Genesis";
  }
  return value;
}

export function getSubStr(str,num1,num2) {
  var subStr1 = str.substr(num1, num2);
  var subStr2 = str.substr(str.length - num2, num2);
  var subStr = subStr1 + "..." + subStr2;
  return subStr;
}
export function  gltime(i) {
  const toDate = new Date(i);
  var d = toDate;
  var localTime = d.getTime();
  var localOffset = d.getTimezoneOffset() * 60000; 
  var utc = localTime + localOffset;
  var offset = this.getClientTimezone; 
  var korean = utc + 3600000 * offset;
  var nd = korean;
  return nd;
}
export function countDecimalPlaces(num) {
  var str = num.toString();
  var dotIndex = str.indexOf(".");
  var decimalPlaces = str.length - dotIndex - 1;
  return decimalPlaces;
}
export function isPositiveInteger(num){
  return /^\d+(?=\.{0,1}\d+$|$)/.test(num)
 // return /^(0|[1-9][0-9]*)$/.test(num);
  //return /^[1-9]+[0-9]*]*$/.test(num);
 }
  
 export function formattedNumber(value) {
  // 将数字转换为字符串
  let str = value.toString();
  // 找到小数点位置
  let decimalIndex = str.indexOf('.');
  // 如果没有小数点，则表示是整数
  if (decimalIndex === -1) {
    decimalIndex = str.length;
  }
  // 从小数点位置开始，每三位加一个逗号
  for (let i = decimalIndex - 3; i > 0; i -= 3) {
    str = str.slice(0, i) + ',' + str.slice(i);
  }

  return str;
}